var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FAAD14;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,0C4.9,0,0,4.9,0,11c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11C22,4.9,17.1,0,11,0z M10.9,17.5 c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9C11.8,17,11.4,17.5,10.9,17.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13,11.6c1.5-1.5,1.8-2.3,1.9-3.3c0.1-1-0.3-1.9-1-2.6c-0.7-0.8-1.8-1.2-2.9-1.2c-1,0-2,0.4-2.7,1.1 C7.5,6.3,7.1,7.3,7.1,8.3c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8C8.7,7,9.7,6,11,6h0c0.7,0,1.3,0.3,1.7,0.7 c0.4,0.4,0.6,0.9,0.6,1.5c0,0.5,0,0.9-1.4,2.3c-0.9,0.9-1.7,1.7-1.8,2.8c0,0.4,0.3,0.8,0.7,0.8c0,0,0.1,0,0.1,0 c0.4,0,0.7-0.3,0.8-0.7C11.7,12.9,12.2,12.4,13,11.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.544e2b3c923a85ac20e15493494f8fdc.svg";
export { ForwardRef as ReactComponent };